import PutawayQueueAdmin from "../components/PutawayQueueAdmin";
import AdminPageHeader from "../components/admin-page-header";
import { useTranslation } from "../i18n";
import "../styles/admin-settings.css";

const AdminPutawayQueue = () => {
    const { t } = useTranslation();
    return (
        <div className="page-data page-data-wide" style={{ height: "calc(100vh - 56px)", overflow: "auto" }}>
            <AdminPageHeader
                titleKey="putaway_queue_title"
                backTo="/admin/warehouse"
                hideSearch
                crumbs={[
                    { labelKey: "admin_panel", to: "/admin" },
                    { labelKey: "warehouse_menu_title", to: "/admin/warehouse" },
                    { labelKey: "putaway_queue_title" },
                ]}
            />
            <div className="admin-settings-section">
                <p className="admin-settings-section-hint">{t("putaway_queue_hint")}</p>
                <PutawayQueueAdmin />
            </div>
        </div>
    );
};

export default AdminPutawayQueue;
